var Slides = function () {

    function init () {
        if ($('.gallery-block.-multiple').length > 0) {
            $('.gallery-block.-multiple .slides').slick({
                infinite: true,
                dots: true,
                slidesToShow: 1
            });
        }
    }
    return {

        init: init
    }

}();
